// extracted by mini-css-extract-plugin
export default {"overlay-play":"styles_overlay-play__c2pEn","logo-play":"styles_logo-play__eUJO0"};